// ===========================================================================
// HEADER | v.3.0.0
// ===========================================================================
(function mainNavigation() {

  // Header
  const $mobileNavOpen = $('#mobile-nav-open');

  // Mainmenu
  const $mainMenu = $('#main-menu');
  const $menuItem = $('.menu-item');
  const $menuClose = $('.menu-close');

  // Submenu
  const $submenu = $('#submenu');
  const $submenuItem = $('.submenu-item');
  const $submenuBack = $('.submenu-back');
  const $submenuClose = $('.submenu-close');


  // Codice relativo alla versione mobile del menu
  if ($(window).width() < 768) {

    // Mostro il menu mobile al touch sul pulsante di navigazione
    $mobileNavOpen.on('click', function () {
      $mainMenu.css('transform', 'translateX(100%)');
    });

    // Chiudo il menu mobile
    $menuClose.on('click', function () {
      $mainMenu.css('transform', 'translateX(-100%)');
    });

    // Mostro il submenu relativo
    $menuItem.on('click', function () {
      const $this = $(this);
      const TARGET = $this.attr('data-target');
      $('#' + TARGET).css('display', 'flex');
      $submenu.css('transform', 'translateX(100%)');
      $mainMenu.css('transform', 'translateX(-100%)');
    });

    // Torno indietro al menu principale
    $submenuBack.on('click', function () {
      $submenu.css('transform', 'translateX(-100%)');
      $mainMenu.css('transform', 'translateX(100%)');
      $submenuItem.css('display', 'none');
    });

    // Chiudo il sottomenu
    $submenuClose.on('click', function () {
      $submenu.css('transform', 'translateX(-100%)');
      $submenuItem.css('display', 'none');
    });

  } else {

    $menuItem.on('click', function () {

      const $this = $(this);
      const TARGET = $this.attr('data-target');

      if ($this.hasClass('active')) {

        // Rimuovo l'effetto "active" da questo elemento del menu
        $this.removeClass('active');

        // Nascondo il relativo submenu target e il wrapper del submenu
        $('#' + TARGET).css('display', 'none');
        $submenu.css('display', 'none');

      } else {

        // Rimuovo l'effetto "active" da tutti gli elementi del menu
        $menuItem.removeClass('active');

        // Aggiungo l'effetto "active" all'elemento cliccato
        $this.addClass('active');

        // Nascondo tutti i submenu
        $submenuItem.css('display', 'none');

        // Mostro il relativo submenu target e il wrapper del submenu
        $('#' + TARGET).css('display', 'flex');
        $submenu.css('display', 'block');

      }
    });
  }


  // Codice per la gestione della slide Customer Care
  // const $customerCare = $('#customer-care');

  // $('.customercare-button').on('click', function () {
  //   $customerCare.addClass('active');
  //   $('.overlay').fadeIn(200);
  // });

  // $('.close-customercare').on('click', function () {
  //   $customerCare.removeClass('active');
  //   $('.overlay').fadeOut(100);
  // });

  // $('.overlay').on('click', function () {
  //   if ($customerCare.hasClass('active')) {
  //     $customerCare.removeClass('active');
  //   }
  // });


}());
